import img01 from '../../../assets/audio-placeholders/01_Turning-in-a-chair.png';
import img02 from '../../../assets/audio-placeholders/02_Head-in-hands.png';
import img03 from '../../../assets/audio-placeholders/03_Side-band.png';
import img04 from '../../../assets/audio-placeholders/04_Self-hug.png';
import img05 from '../../../assets/audio-placeholders/05_Standing-on-a-clock.jpg';
import img06 from '../../../assets/audio-placeholders/06_Clock-on-a-chair.jpg';
import img07 from '../../../assets/audio-placeholders/07_Head-eye_differentiation.png';
import img08 from '../../../assets/audio-placeholders/08_Opposites.jpg';
import img09 from '../../../assets/audio-placeholders/09_Standing-at-a-Desk.jpg';
import img10 from '../../../assets/audio-placeholders/10_Turn-in-standing.jpg';

/**
 * Must match object keys in the Supabase `audio` bucket exactly (case-sensitive).
 * If playback fails, open Storage → audio and copy each filename here.
 */
export const AUDIO_STORAGE_BUCKET =
  (import.meta.env.VITE_SUPABASE_AUDIO_BUCKET as string | undefined) ?? 'audio';

const STORAGE_FILES = [
  'QT-A-01_Turning-in-a-chair.mp3',
  'QT-A-02_Head-in-Hands.mp3',
  'QT-A-03_Side-Bend.mp3',
  'QT-A-04_Self-hug-in-a-chair.mp3',
  'QT-A-05_Standing-on-a-clock.mp3',
  'QT-A-06_Clock-on-a-chair.mp3',
  'QT-A-07_Head-eye-differentiation.mp3',
  'QT-A-08_Opposites.mp3',
  'QT-A-09_Standing-at-a-desk.mp3',
  'QT-A-10_Turn-in-standing.mp3'
] as const;

export type AudioQtCoverVariant = 'lilacDawn' | 'tealMist' | 'coralGlow';

export type AudioQtItem = {
  id: string;
  title: string;
  description: string;
  /** Path inside the `audio` Storage bucket (no leading slash). */
  storagePath: string;
  coverUrl: string;
  coverVariant: AudioQtCoverVariant;
};

const META: Omit<AudioQtItem, 'storagePath' | 'coverUrl'>[] = [
  {
    id: 'listen-qt-a-01',
    title: 'Turning in a chair',
    description: 'Trust your own reference point.',
    coverVariant: 'lilacDawn'
  },
  {
    id: 'listen-qt-a-02',
    title: 'Head in hands',
    description: 'Connect your patterns, Find calm.',
    coverVariant: 'tealMist'
  },
  {
    id: 'listen-qt-a-03',
    title: 'Side bend',
    description: 'Expand your dimensions, Explore your beliefs.',
    coverVariant: 'coralGlow'
  },
  {
    id: 'listen-qt-a-04',
    title: 'Self-hug in a chair',
    description: 'Connect with your resources, Self-appreciation, Safety.',
    coverVariant: 'lilacDawn'
  },
  {
    id: 'listen-qt-a-05',
    title: 'Standing on a clock',
    description: '–Emotional center and confidence.',
    coverVariant: 'tealMist'
  },
  {
    id: 'listen-qt-a-06',
    title: 'Clock on a chair',
    description: 'Confidence and centering.',
    coverVariant: 'coralGlow'
  },
  {
    id: 'listen-qt-a-07',
    title: 'Head–eye differentiation',
    description: 'Free habitual body and mind-patterns.',
    coverVariant: 'lilacDawn'
  },
  {
    id: 'listen-qt-a-08',
    title: 'Opposites',
    description: 'Contrast small movements to clarify sensing and choice.',
    coverVariant: 'tealMist'
  },
  {
    id: 'listen-qt-a-09',
    title: 'Standing at a desk',
    description: 'Connect self-image in new ways, Diagonals.',
    coverVariant: 'coralGlow'
  },
  {
    id: 'listen-qt-a-10',
    title: 'Turn in standing',
    description: 'Expand your horizon, Confidence and balance.',
    coverVariant: 'lilacDawn'
  }
];

const COVERS = [img01, img02, img03, img04, img05, img06, img07, img08, img09, img10];

export const AUDIO_QTS: AudioQtItem[] = STORAGE_FILES.map((file, i) => {
  const row = META.at(i);
  const cover = COVERS.at(i);
  if (!row || cover === undefined) {
    throw new Error(`audioQts: mismatched meta, cover, or storage list at index ${i}`);
  }
  return {
    ...row,
    storagePath: file,
    coverUrl: cover
  };
});

/** Signed URLs shorter than this may expire mid-session (seconds). */
export const AUDIO_SIGNED_URL_TTL_SEC = 60 * 60 * 12;
